import { Vue } from 'vue-class-component';

import duration from '@/transformers/duration';
import { UNLIMITED_EVENT_DURATION_IN_MIN } from '@Ravnur-Inc/shared/types/Live';

class Props {
  value: number;
}

export default class HumanizedDuration extends Vue.with(Props) {
  get duration() {
    return this.value === UNLIMITED_EVENT_DURATION_IN_MIN
      ? this.$t('live-events', 'unlimited_duration')
      : duration(this.value);
  }

  render() {
    return <span>{this.duration}</span>;
  }
}
